import { GOOGLE_ANALYTICS_ID } from './env-var';

export const GoogleAnalyticsScript = () => {
  if (!GOOGLE_ANALYTICS_ID.get()) {
    return null;
  }

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID.get()}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            if (typeof window !== 'undefined') {
              window.dataLayer = window.dataLayer || [];

              function gtag(){
                dataLayer.push(arguments);
              }

              gtag('js', new Date());
              // gtag('config', '${GOOGLE_ANALYTICS_ID.get()}', {
              //   page_path: window.location.pathname,
              // });
            }
          `,
        }}
      />
    </>
  );
};
